//редьюесеры
import { routerReducer as routing  } from 'react-router-redux';
import { combineReducers } from 'redux';
import { AppConstants }  from './models/application';
import UserReducer from './models/user/reducer';
import FeedReducer from './models/feeds/reducer';

const AppErrors = (state = null, action) => {
    const {action_type, error} = action;

    if (action_type === AppConstants.RESET_APP_ERRORS) {
        return null;
    } else {
        if (error) {
            return error;
        }
    }

    return state;
};


const ApplicationReducer = combineReducers({
    UserReducer,
    FeedReducer,
    AppErrors,
    routing
});

export default ApplicationReducer;


// WEBPACK FOOTER //
// ./src/reducers.js